module.exports = __webpack_public_path__ + "static/media/368.92a04f25.webp";